module.exports = __webpack_public_path__ + "img/image-indent-left.31d7fb9c.svg";